module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/default-city.0daff8861d5d878ce5986afc567c8731.png";